import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import Page from '../../components/page';
import { List, Dialog } from 'antd-mobile';
import moment from 'moment';
import './index.less';

const PageModel = props => {
	const [list, setList] = useState([]);

	const getList = async (type) => {
		const result = await Request.get({
			url: '/upkeep/upkeep_list',
			data:{type}
		});
		if (!result) return;
		const list = result.data.list || [];
		setList(list);
	};

	useEffect(() => {
		const { type } = props.match.params;
		console.log('传过来的;', type);
		if (type) {
			//获取当前微信用户绑定的店铺所有设备的保养记录
			getList(type)
		}

	}, [123]);


	return (
		<Page {...{ page: 'upkeeplist', showFooter: false, title: '保养信息' }} {...props}>
			<List>
				{list.length > 0 && list.map((item, index) => {
					return (
						<List.Item extra={moment(item.createdAt).format('YYYY-MM-DD')} key={index} onClick={() => { 
							props.history.push('/upkeepinfo/' + item.id) 
						}}>
							<div className='item-title'>{item.equipmentName}({item.companyName})</div>
						</List.Item>
					)
				})

				}
				{
					list.length === 0 && <div style={{ textAlign: 'center', padding: '10px' }}>暂无数据</div>
				}

			</List>
		</Page>
		
	);
};

export default PageModel;
